import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import api from '../api';
import { 
  FETCH_EXPENSES,
  ON_SAVE_EXPENSES,
  ON_EDIT_EXPENSES,
  DELETE_EXPENSES
} from 'constants/ActionTypes';
import { showExpensesLoader, fetchExpensesSuccess, showExpensesMessage, saveExpensesSuccess } from 'actions/Expenses';
import { userSignOut } from 'actions/Auth';

function* getExpenses({ payload }) {
  try {
    const { from, to, page, limit, lastEvaluatedKey } = payload;
    yield put(showExpensesLoader({page}));
    const authToken = localStorage.getItem('token');
    const expenses = yield call(api.expensesApi.getExpenses, { authToken, from, to, page, limit, lastEvaluatedKey });

    if (expenses.errorMessage) {
      yield put(showExpensesMessage(expenses.errorMessage, true));
    } else {
      yield put(fetchExpensesSuccess(expenses));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showExpensesMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* saveExpenses({ payload }) {
  try {
    yield put(showExpensesLoader());
    const authToken = localStorage.getItem('token');
    const expenses = yield call(api.expensesApi.addExpenses, { payload, authToken });

    if (expenses.errorMessage) {
      yield put(showExpensesMessage(expenses.errorMessage, true));
    } else {
      yield put(saveExpensesSuccess(expenses));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showExpensesMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* editExpenses({ payload }) {
  try {
    yield put(showExpensesLoader());
    const authToken = localStorage.getItem('token');
    const expenses = yield call(api.expensesApi.editExpenses, { payload, authToken });

    if (expenses.errorMessage) {
      yield put(showExpensesMessage(expenses.errorMessage, true));
    } else {
      yield put(saveExpensesSuccess(expenses));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showExpensesMessage(error.message || error, true));
    yield put(userSignOut());
  }
}

function* deleteExpenses({ payload }) {
  try {
    yield put(showExpensesLoader());
    const authToken = localStorage.getItem('token');
    const expenses = yield call(api.expensesApi.deleteExpenses, { payload, authToken });

    if (expenses.errorMessage) {
      yield put(showExpensesMessage(expenses.errorMessage, true));
    } else {
      yield put(saveExpensesSuccess(expenses));
    }
  } catch (error) {
    console.log('error', error);
    yield put(showExpensesMessage(error.message || error, true));
    yield put(userSignOut());
  }
}


export function* fetchExpenses() {
  yield takeEvery(FETCH_EXPENSES, getExpenses);
}

export function* createExpenses() {
  yield takeEvery(ON_SAVE_EXPENSES, saveExpenses);
}

export function* updateExpenses() {
  yield takeEvery(ON_EDIT_EXPENSES, editExpenses);
}

export function* removeExpenses() {
  yield takeEvery(DELETE_EXPENSES, deleteExpenses);
}

export default function* rootSaga() {
  yield all([
    fork(fetchExpenses),
    fork(createExpenses),
    fork(updateExpenses),
    fork(removeExpenses),
  ]);
}



// WEBPACK FOOTER //
// ./sagas/Expenses.js